import { TaggingConfig } from '@afe/tagging';
import { TaggingGtmConnector } from '@afe/tagging/gtm-connector';
import { TaggingDynatraceConnector } from '@afe/tagging/dynatrace-connector';

export const taggingConfig: TaggingConfig = {
    connectors: [
        TaggingGtmConnector,
        TaggingDynatraceConnector,
    ],
};
